import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { IsLoginChecker } from '../../../common/checkers/IsLoginChecker';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { t } from '../../../common/getTranslations';
import { isTrue } from '../../../common/shared/utils/isTrue';
import { Layout } from '../../../design-system/layout/Layout';
import { BuyTicketContainer } from '../../../domain/buy/ticket/container/BuyTicketContainer';
import { ContentAgeAuthLimitCheckerHeadless } from '../../../domain/common/headless/ContentAgeAuthLimitCheckerHeadless';
import { ApiErrorBoundary } from '../../../errors/ApiErrorBoundary.class';
import { ContentTicketInfo } from '../../../graphql/generated/types';
import { CommonMobileHeaderType } from '../../../header/constants';
import { CACHE_ONLY_CONFIG } from '../../../reactQuery/constant';
import { ReactQueryFetcher } from '../../../reactQuery/ReactQueryFetcher';
import { useContentHomeOverviewQuery } from '../../../wrapper/contentWrapper';
import { useContentBuyTicketPageQuery, useContentMyTicketQuery } from '../../../wrapper/ticketWrapper';
function BuyTicket() {
  const router = useRouter();
  const {
    seriesId: seriesIdQuery,
    productId: productIdQuery,
    from: fromQuery,
    waitfreeBlock: waitfreeBlockQuery
  } = router.query;
  const seriesId = Number(seriesIdQuery || '');
  const productId = productIdQuery ? Number(productIdQuery || '') : undefined;
  const from = fromQuery ? Number(fromQuery || '') : undefined;
  const waitfreeBlocked = waitfreeBlockQuery ? isTrue(waitfreeBlockQuery as string) : undefined;
  return <IsLoginChecker>
      <ApiErrorBoundary>
        <ReactQueryFetcher reactQuery={useContentHomeOverviewQuery} variables={{
        seriesId
      }} options={{
        ...CACHE_ONLY_CONFIG
      }}>
          <ContentAgeAuthLimitCheckerHeadless seriesId={seriesId} location="contenthome">
            <ReactQueryFetcher reactQuery={useContentMyTicketQuery} variables={{
            seriesId,
            includeSingle: true
          }}>
              {({
              contentMyTicket
            }) => <ReactQueryFetcher reactQuery={useContentBuyTicketPageQuery} variables={{
              seriesId
            }}>
                  {({
                contentBuyTicketPage
              }) => {
                if (!contentBuyTicketPage?.ticketInfo || !contentBuyTicketPage?.bannerList) {
                  return null;
                }
                return <BuyTicketContainer seriesId={seriesId} productId={productId} from={from} waitfreeBlocked={waitfreeBlocked} contentMyTicket={contentMyTicket} ticketInfo={contentBuyTicketPage?.ticketInfo as ContentTicketInfo} bannerList={contentBuyTicketPage?.bannerList} />;
              }}
                </ReactQueryFetcher>}
            </ReactQueryFetcher>
          </ContentAgeAuthLimitCheckerHeadless>
        </ReactQueryFetcher>
      </ApiErrorBoundary>
      <TrackPageViewContainer trackObj={{
      section: '이용권충전',
      page: '이용권충전',
      actionType: 'Pageview',
      actionName: '이용권충전_화면',
      page_meta: {
        id: String(seriesId),
        type: 'seriesId',
        series_id: String(seriesId)
      },
      customProps: {
        user_action: 'pv'
      }
    }} />
    </IsLoginChecker>;
}
BuyTicket.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('ticket_purchase_title')} mobileLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true,
    headerType: CommonMobileHeaderType.FourDepth,
    shouldShowFooterLinkMenu: false
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true
  }}>
      {page}
    </Layout>;
};
export default BuyTicket;